(function($, undefined) {
	'use strict';
	var form;

	var init = function() {
		form = Fw.component.models().form;

		$('body').on('click', '.js-clipboard-link', function() {
			var textarea = $('<textarea>'+$(this).attr('data-url')+'</textarea>');
			$('body').append(textarea);
			
			textarea[0].select();
			document.execCommand('copy');
			
			textarea.remove();
			
			form.showErrorPopupAnimation('clipboard-success');
		});
	};
	
	$(init);

})(jQuery);